<template>
  <div class="highlights-selected-products-container">
    <span class="products-title"> <b>Produtos destacados</b> (opcional)</span>
    <span class="products-description"
      >Selecione quais produtos vão estar na capa do modelo de destaque. O limite é de {{ selectableItemsLimit }} produtos. Se não selecionados, eles serão
      escolhidos aleatoriamente.</span
    >
    <chip-list
      allow-select-items
      dialog-title="Produtos destacados"
      dialog-width="874px"
      :dialog-description="dialogDescription"
      details-type="dialog"
      variant="products"
      button-activator
      button-activator-label="Selecionar produtos destacados"
      :selected-items-limit="selectableItemsLimit"
      :headers="headers"
      :products="selectableItems"
      :items="formattedSelectedItems"
      :selected-items.sync="selectedItems"
      :disable-items-selection="finishedHighlight"
      :disabled="finishedHighlight"
    />
  </div>
</template>
<script>
import { highlightOffer } from '../../../../mixins/highlight-offer'

export default {
  name: 'SelectedProducts',
  components: {
    ChipList: () => import('@/components/ChipList.vue'),
  },
  mixins: [highlightOffer],
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    openProductsDialog: false,
    selectedItems: [],
  }),
  computed: {
    items() {
      return this.highlightOffer.products.map((product) => {
        return this.highlightOffer.id ? { ...product, select: product?.showHome } : product
      })
    },
    finishedHighlight() {
      return this.highlightStatus === 'FINISHED'
    },
    selectableItems() {
      const selectedSkus = this.selectedItems.map((item) => item.sku)
      return this.items.map((item) => {
        return {
          ...item,
          isSelectable: !(selectedSkus.length >= this.selectableItemsLimit && !selectedSkus.includes(item.sku)),
        }
      })
    },
    selectableItemsLimit() {
      return this.isExpandedModel ? 2 : 4
    },
    dialogDescription() {
      return `Selecione quais produtos vão fazer estar em na capa do modelo de destaque. O limite é de ${this.selectableItemsLimit} produtos na capa. Caso a quantidade máxima a ser selecionada não seja atingida os produtos na capa serão dispostos de forma aleatória.`
    },
    formattedSelectedItems() {
      return this.selectedItems.map((item) => `${item.sku} - ${item.name}`)
    },
    headers() {
      return [
        {
          text: '',
          value: 'select',
          width: '10%',
          sortable: false,
        },
        {
          text: '',
          value: 'image',
          width: '10%',
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '12%',
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '18%',
        },
        {
          text: 'Nome',
          value: 'name',
          width: '45%',
        },
      ]
    },
  },
  watch: {
    selectedItems(newValue) {
      const skus = newValue.map((product) => product.sku)
      const products = this.selectableItems.map((product) => {
        return { ...product, showHome: skus.includes(product.sku) }
      })
      this.setHighlightKeyValue({ payload: products, key: 'products' })
    },
  },
  mounted() {
    this.selectedItems = this.highlightOffer.products
      .map((product) => {
        return {
          ...product,
          isSelectable: true,
        }
      })
      .filter((item) => item.showHome)
  },
}
</script>
<style lang="scss" scoped>
.highlights-selected-products-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .products-title {
    color: $cinza-d10;
    font-weight: 400;
    font-size: 18px;
    b {
      font-weight: 700;
    }
  }
  .products-description {
    color: #656565;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.4px;
  }
}
</style>
